import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'sb-react-intl'

import Price from 'components/text/Price/Price'

import messages from './messages'

import s from './TotalPrice.scss'


const TotalPrice = ({ isFetching, value }) => (
  <div className={s.total} id="billSubscriptionTotalRow">
    <FormattedMessage {...messages.total} />:
    <div className={s.price}>
      <Price value={value} loading={isFetching} isCents />
    </div>
  </div>
)

TotalPrice.propTypes = {
  isFetching: PropTypes.bool,
  value: PropTypes.number.isRequired,
}


export default React.memo(TotalPrice)
